import React from 'react'

//Custom Login Page - to display nothing because we use keycloak for login
export default () => <div>You are logged out...</div>
